import { Link, Typography } from '@iheartjane/reefer';

export const MarketingConsent = () => {
  return (
    <Typography ml={16}>
      I consent to Jane using my email and in-app notifications to send me
      marketing materials, special offers, recommendations and more, in
      accordance with Jane's{' '}
      <Link href="https://www.iheartjane.com/privacy-policy">
        Privacy Policy.
      </Link>
    </Typography>
  );
};
